module.exports = __webpack_public_path__ + "static/media/features-home-element-02.4b28815c.png";